import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';
import { KEY_DOWN_COMMAND } from 'lexical';

export default function HashToolbarOpenerPlugin({ containerRef, setContextMenu } : any) {
  const [editor] = useLexicalComposerContext();

const moveFocus = (
  items: HTMLLIElement[],
  from: number,
  to: number
) => {
  items[from].classList.remove('list-highlight');

  items[to].classList.add('list-highlight');
};


  useEffect(() => {
    const removeListener = editor.registerCommand(
      KEY_DOWN_COMMAND,
      (event) => {
        if (event.key === '#' || (event.key === '3' && event.shiftKey)) {
          const selection = window.getSelection();
          if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            let rect = range.getBoundingClientRect();
            if (range.collapsed) {
              const currentRange = range.cloneRange();
              const marker = document.createElement('span');
              marker.style.display = 'inline-block';
              marker.textContent = "\u200B";

              range?.insertNode(marker);
              rect = marker?.getBoundingClientRect();

              const parent = marker.parentNode;
              marker?.remove();
              if (parent) {
                parent?.normalize();
              }

              selection?.removeAllRanges();
              selection?.addRange(currentRange);
            }
          setContextMenu({ x: rect.left, y: rect.bottom });
            const toolbar = document.querySelector(
              ".reference-elem"
            ) as HTMLUListElement | null;

            if (toolbar) {
              const firstItem = toolbar.querySelector("li") as HTMLLIElement | null;

              if (firstItem) {
                firstItem.tabIndex = 0;
                firstItem.classList.add('list-highlight')
              }
            }
          }
          return false;
        }
if (event.key === 'ArrowDown') {
  const toolbar = document.querySelector(".reference-elem") as HTMLUListElement | null;
  if (!toolbar) return false;

  const items = Array.from(toolbar.querySelectorAll<HTMLLIElement>("li"));
  if (items.length === 0) return false;

  // Find currently highlighted item
  const currentIndex = items.findIndex(item => item.classList.contains('list-highlight'));

  // If none highlighted, highlight the first item
  const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % items.length;
  event.preventDefault();
  moveFocus(items, currentIndex === -1 ? 0 : currentIndex, nextIndex);

  // Optional: scroll item into view like focus would
  items[nextIndex].scrollIntoView({ block: 'nearest' });

  return true;
}

if (event.key === 'ArrowUp') {
  const toolbar = document.querySelector(".reference-elem") as HTMLUListElement | null;
  if (!toolbar) return false;

  const items = Array.from(toolbar.querySelectorAll<HTMLLIElement>("li"));
  if (items.length === 0) return false;

  const currentIndex = items.findIndex(item => item.classList.contains('list-highlight'));
  // Wrap around to the last item if at the start
  const prevIndex = currentIndex === -1 ? items.length - 1 : (currentIndex - 1 + items.length) % items.length;
  event.preventDefault()
  moveFocus(items, currentIndex === -1 ? 0 : currentIndex, prevIndex);
  items[prevIndex].scrollIntoView({ block: 'nearest' });

  return true;
}

        return false;
      },
      0
    );

    return () => {
      removeListener();
    };
  }, [editor, setContextMenu, containerRef]);

  return null;
}
